import React from 'react';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { DateRange } from '@yme/assets/icons';
import { Col, Container, Row } from '@yme/atoms/grid';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/index';
import { getRootLang, getRTL } from '@yme/selectors/common';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel1, RegularTextLevel3, RegularTextLevel4 } from '@yme/tokens/typography';
import { getFormattedDate } from '@yme/utils/common';
import { HeroSectionContent } from './HeroSectionContent';
import { SubTitlePanel } from './SubTitlePanel';
export function HeroSection(props) {
    const { title, offerDescription, backgroundImage, dateFrom, dateTo, labels, subtitle, date, isRemoveBottomIndent, } = props;
    const isRightToLeft = useSelector(getRTL);
    const lang = useSelector(getRootLang);
    const { isMobileView, isTabletView, isInfiniteDesktopView } = useWindowSize();
    if (!title || !subtitle || !offerDescription) {
        return null;
    }
    const formattedDate = getFormattedDate({
        date,
        lang,
    });
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement("section", { ...(isRightToLeft
                ? {
                    dir: 'rtl',
                }
                : {}), style: {
                backgroundColor: colorCoreWhite1000,
            } },
            React.createElement(HeroSectionContent, { backgroundImage: backgroundImage },
                React.createElement(SubTitlePanel, { subtitle: subtitle, date: formattedDate }),
                !isMobileView && (
                // JSX for desktop and large desktop views
                React.createElement(HeadingLevel1, { color: colorCoreWhite1000 }, title))),
            React.createElement(Container, null,
                React.createElement(Row, { justifyContent: "center" },
                    React.createElement(Col, { lg: 6 },
                        React.createElement(FlexWrapper, { flexDirection: "column", pt: "24px", pb: "24px", ptTablet: "32px", pbTablet: "32px", ptDesktop: "32px", pbDesktop: "32px" },
                            isMobileView && (
                            // JSX for mobile and tablet views
                            React.createElement(FlexWrapper, { mb: "16px" },
                                React.createElement(HeadingLevel1, null, title))),
                            React.createElement(FlexWrapper, null,
                                isInfiniteDesktopView && (React.createElement(RegularTextLevel3, null,
                                    React.createElement("div", { dangerouslySetInnerHTML: {
                                            __html: offerDescription,
                                        } }))),
                                (isMobileView || isTabletView) && (React.createElement(RegularTextLevel3, null,
                                    React.createElement("div", { dangerouslySetInnerHTML: {
                                            __html: offerDescription,
                                        } })))),
                            Boolean(date) && (React.createElement(FlexWrapper, { gap: "4px", alignItems: "center" },
                                dateFrom || dateTo ? (React.createElement(SVGIcon, { type: DateRange, pathFill: colorCoreBlack900Base, size: ICON_SIZE.xxs })) : (''),
                                React.createElement(RegularTextLevel4, { color: colorCoreBlack300 },
                                    Boolean(dateFrom) &&
                                        `${labels.offersPromo_validFrom_text} ${dateFrom && format(dateFrom, 'dd-MM-yyyy')} `,
                                    Boolean(dateTo) &&
                                        `${labels.offersPromo_validTo_text} ${dateTo && format(dateTo, 'dd-MM-yyyy')}`))))))))));
}
HeroSection.displayName = 'HeroSection_AEMComponent';
